import gql from 'graphql-tag';

export const UPLOAD_WILL_MUTATION = gql`
  mutation uploadWill(
    $testatorId: ID!
    $fileBase64: String!
    $acknowledgedMismatch: Boolean
  ) {
    uploadWill(
      testatorId: $testatorId
      fileBase64: $fileBase64
      acknowledgedMismatch: $acknowledgedMismatch
    ) {
      id
      willVersionId
      status
      url
      comments
      version
      createdAt
    }
  }
`;

export const UPDATE_UPLOADED_WILL_MUTATION = gql`
  mutation updateUploadedWill(
    $id: ID!
    $uploadedWillInput: UploadedWillInput!
  ) {
    updateUploadedWill(id: $id, uploadedWillInput: $uploadedWillInput) {
      id
      status
      url
      comments
      version
      willVersionId
    }
  }
`;

export const CREATE_UPLOADED_WILL_PRESIGNED_URL_MUTATION = gql`
  mutation createUploadedWillPresignedUrl($id: ID!) {
    createUploadedWillPresignedUrl(id: $id)
  }
`;

export const CREATE_PRE_EXISTING_WILL_MUTATION = gql`
  mutation createPreExistingWill(
    $testatorId: ID!
    $fileBase64: String!
    $acknowledgedMismatch: Boolean
  ) {
    createPreExistingWill(
      testatorId: $testatorId
      fileBase64: $fileBase64
      acknowledgedMismatch: $acknowledgedMismatch
    ) {
      id
      testatorId
      url
      createdAt
    }
  }
`;

export const CREATE_PRE_EXISTING_WILL_PRESIGNED_URL_MUTATION = gql`
  mutation createPreExistingWillPresignedUrl($id: ID!) {
    createPreExistingWillPresignedUrl(id: $id)
  }
`;

export const CREATE_WILL_VERSION_PRESIGNED_URL_MUTATION = gql`
  mutation createWillVersionPresignedUrl($id: ID!) {
    createWillVersionPresignedUrl(id: $id)
  }
`;
